module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_2_m.dd27dd359fdf64bd3e65294ef6ad0e07.png";